import {SelectItem} from '@components/inputs/select/Select.component';
import {ClientInvoiceAddress} from '@store/clients/details';
import {ClientsService, DatahubSpec} from '@store/clients/services';
import {Pagination} from '@store/common/pagination.model';
import {TableFilter, TableFilterType} from '@store/common/tableFilter.model';

export interface ManageClientContract {
  clientOrganisationId?: number;
  id?: number;
  clientUnit?: SelectItem;
  contractName?: string;
  startDate?: Date;
  endDate?: Date;
  contractReference?: string;
  invoiceAddress?: ClientInvoiceAddress;
  clientInvoiceAddressId?: number;
  datahubSpec?: DatahubSpec;
  services?: ClientsService[];
  originContract?: ClientsContract;
}

export interface ClientsContractsFilters {
  filterExpiredContracts: boolean;
  search: string;
  tableFilters: TableFilter[];
}

export namespace ClientsContractsFilters {
  export const initTableFilters = (clientId?: string, clientUnitId?: string) => TableFilterType.initTableFilters([
    TableFilterType.CLIENT_ORGANISATION,
    TableFilterType.CLIENT_ORGANISATION_UNIT,
    TableFilterType.SUPPLIER_ORGANISATION,
    TableFilterType.SUPPLIER_ORGANISATION_UNIT,
    TableFilterType.WASTE,
    TableFilterType.CONTAINER
  ]).map((f) => ({
    ...f,
    hide: (!!clientId && f.type === TableFilterType.CLIENT_ORGANISATION) || (!!clientUnitId && f.type === TableFilterType.CLIENT_ORGANISATION_UNIT),
    values: (f.type === TableFilterType.CLIENT_ORGANISATION && !!clientId) ? [{
      label: '',
      value: clientId
    }] : (f.type === TableFilterType.CLIENT_ORGANISATION_UNIT && !!clientUnitId) ? [{
      label: '',
      value: clientUnitId
    }] : [],
  }));
}

export interface ClientsContractsPagination extends Pagination {
  data: ClientsContract[];
}

export interface ClientsContractUI {
  id: number;
  selected: boolean;
}

export interface ClientsContract {
  id: number;
  contractReference: string;
  contractName: string;
  startDate: Date;
  endDate: Date;
  clientOrganisationUnitId: number;
  clientOrganisationUnitName: string;
  clientOrganisationId: number;
  clientOrganisationName: string;
  servicesCount: number;
  services: ClientsService[];
  invoiceAddress: ClientInvoiceAddress;
  pickupSupplierUnitName: string;
  datahubSpec: DatahubSpec;
}

export namespace ClientsContract {
  export const toManageClientsContract = (contract: ClientsContract): ManageClientContract => ({
    id: contract.id,
    clientUnit: {value: '', label: contract.clientOrganisationUnitName},
    contractName: contract.contractName,
    startDate: contract.startDate,
    endDate: contract.endDate,
    contractReference: contract.contractReference,
    invoiceAddress: contract.invoiceAddress,
    clientInvoiceAddressId: contract.invoiceAddress?.clientInvoiceAddressId,
    datahubSpec: contract.datahubSpec,
    clientOrganisationId: contract.clientOrganisationId,
    services: contract.services,
    originContract: contract,
  });
}
